import CopyButton from "@/components/CopyButton";
import useModal from "@/hooks/useModal";
import { buildRegistrationOverrideUrl } from "@/lib/urlUtils";
import { showSnackbar } from "@/lib/snackbarUtils";

interface CopyRegistrationOverrideLinkModalProps {
  eventId: string;
  eventSlug: string;
  onClosed: () => void;
}

export default function CopyRegistrationOverrideLinkModal({
  eventId,
  eventSlug,
  onClosed
}: CopyRegistrationOverrideLinkModalProps) {
  const { close, Modal } = useModal();

  const registrationOverrideUrl = buildRegistrationOverrideUrl(eventSlug, eventId);

  return (
    <Modal
      className="max-w-[500px] p-6 pr-2"
      onClosed={onClosed}
      headline="Copy Registration Override Link"
      data-testid="copy-registration-override-link-modal"
      action={
        <CopyButton
          textToCopy={registrationOverrideUrl}
          ariaLabel="Copy registration override link"
          variant="filled"
          testId="copy-link-button"
          onCopied={async () => {
            showSnackbar("Registration override link copied to clipboard", { close: true });
            await close();
          }}
        >
          Copy Link
        </CopyButton>
      }
      hasFormElements={false}
    >
      <div className="space-y-4">
        <p>
          Important: <strong>Please use this registration link carefully</strong>
          <br />
          Anyone with access to it can override restrictions such as attendance limits and registration closing dates to
          register for the event.
        </p>
        <div className="bg-sys-brand-surface-container p-3 rounded border text-sm text-sys-brand-on-surface-variant break-all">
          {registrationOverrideUrl}
        </div>
      </div>
    </Modal>
  );
}
